import React, { Component } from 'react';
import LOGO from "../../static/logo.svg";
import LOGOwhite from "../../static/logo-white.svg";
import './_header.scss';
import { Link, DirectLink, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
var qs = require('qs');  

class HeaderNoMenu extends Component {
	   
	   constructor(props) {
	        super(props);
	        this.toggleClass = this.toggleClass.bind(this);
	        this.handleSetActive = this.handleSetActive.bind(this);
	        this.toggleBut = this.toggleBut.bind(this);
	        this.handleSubmit = this.handleSubmit.bind(this);
	        this.state = {
	            menuActive: false,
	            buttonActive: false,
	            formActive: false,
	            firstname:"", 
	            email:"",
	            message: "Message receive",
	            type: "initial",
	            sending: false,
	            message: ""
	        };
	    }
	    
	    toggleClass() {
	        const currentState = this.state.menuActive;
	        this.setState({ menuActive: !currentState });
	    };
	    
	    toggleBut() {
	        const currentState = this.state.formActive;
	        this.setState({ formActive: !currentState, message: "" });
	        
	        if (!this.state.formActive) {
		        document.body.classList.add('modal-open');
	        } else {
		        document.body.classList.remove('modal-open'); 
	        }
	    };
	    
	    handleSetActive(name, other){
		    var targetName = document.getElementsByClassName(name)
		    //console.log('name: ', name, 'clicked: ', targetName, 'prev element: ', targetName["0"].previousElementSibling);
		    targetName["0"].classList.add("active");
		    if(targetName["0"].previousElementSibling){
			    targetName["0"].previousElementSibling.classList.remove("active");
		    }
		    
		    if (name === "features") {
			     this.setState({ buttonActive: false });
		    } else {
			     this.setState({ buttonActive: true });
		    }
		    
		};
		
		handleSubmit(event){ 
		  event.preventDefault();
		  this.setState({ status: 'Sending... ', sending: true });
		  
		  var data = {
			  	form_name: this.state.firstname,
			  	form_email: this.state.email,
			  	form_msg: this.state.message
			  }	
			  
		   var dataForm = new FormData();
				dataForm.append('form_name', this.state.firstname);
				dataForm.append('form_email', this.state.email);
				dataForm.append('form_msg', this.state.message);
			
			//console.log('form data: ',data);
			
			for (var key of dataForm.entries()) {
			       // console.log(key[0] + ', ' + key[1]);
			    }
			
			
			fetch('mail.php', {
		        method: 'POST',
		        headers: { "Content-type": "application/x-www-form-urlencoded"},
		        body: qs.stringify(data)
		    }).then(function(jsonData) {
	            return JSON.stringify(jsonData);
	        }).then(jsonStr => {
		        this.setState({ status:"Your Message has been sent, we will contact you as soon as possible to schedule a meeting.", sending:false })
			    
			  //  console.log(jsonStr);
			});
		  
		 };

		 

	   
	  
	   render() {
		  return (
			 <div className="top-wrapper">
			 	<div className={this.state.formActive ? 'top-wrapper-modal active': 'top-wrapper-modal'}>
				 	<div className='modal'>
				 		<button className="close-modal" onClick={this.toggleBut}>
				 			<i className="fas fa-times"></i>
				 		</button>
				 		<div className="container">
				 			<div className="row">
				 				<div className="col-12 text-center">
				 					<h2>Plan de Mantenimiento</h2>
				 					<p className="lead">Establecer un plan de mantenimiento para evitar hacks y mantener la presencia en línea del sitio Datasys.la . El plan contiene los siguientes rubros.:</p>
				 				</div>
				 			</div>
				 			<div className="row">
				 				<div className="col-md-4">
				 					<ul>
				 						<li>Análisis del sitio actual </li>
				 						<li>Actualización del WordPress y sus plugins</li>
				 						<li>Monitoreo diario del bienestar del sitio </li>
				 					</ul>
				 				</div>
				 				<div className="col-md-4">
				 					<ul>
				 						<li>Backup mensual del sitio</li>
				 						<li>Google Search Console</li>
				 						<li>Sitemap</li>
				 					</ul>
				 				</div>
				 				<div className="col-md-4">
				 					<ul>
				 						<li>Reporte Mensual </li>
				 						<li>Google Analytics </li>
				 						<li>LinkedIn </li>
				 						<li>Facebook </li>
				 					</ul>
				 				</div>
				 			</div>
				 			<div className="row">
				 				<div className="col-12">
				 					
				 					<form method="POST" action="mail.php" onSubmit={this.handleSubmit}className={this.state.sending ? 'lead-form active': "lead-form"}>
				 						<p>Send in your details and we will contact you to arrange a meeting at your convenience.</p>
				 						<input type="text" placeholder="Your Name" id="form_name" value={this.state.firstname} onChange={(ev)=>this.setState({firstname:ev.target.value})}disabled={this.state.sending} required	/>
				 						<input type="email" placeholder="Your Email" id="form_email" value={this.state.email} onChange={(ev)=>this.setState({email:ev.target.value})} disabled={this.state.sending} required/>
				 						<input type="hidden" value="message received" id="form_msg"/>
				 						
				 						<p className="status">{this.state.message}</p>
				 						
				 						<button type="submit" className="btn" disabled={this.state.sending}>Get in touch</button>
				 						
				 						
				 					</form>
				 				</div>
				 			</div>
				 		</div>
					</div>
				</div>
			  <header className="header">
			    <div className="container-fluid">
			      <div className="row">
			        <div className="col-12">
			          <div className="header-content">
			            <span className="header-logo">
			              <a href="/">Squidsource </a>
			            </span>
			            
			            <button className={this.state.buttonActive ? 'btn call-to-action active': "btn call-to-action"} onClick={this.toggleBut}><i className="far fa-caret-square-down"></i><span>Get Solutions</span></button>
			            
			            			          </div>
			        </div>
			      </div>
			    </div>
			    
			    
			    
			  </header>
			  </div>
		  )
		}
  };

export default HeaderNoMenu;



// WEBPACK FOOTER //
// ./src/components/header-no-menu/index.js